module.exports = __webpack_public_path__ + "static/media/favourites.c529c000.svg";